const SETTINGS = {
  DEBUG: false,
  HOST: '',
  GOOGLE_API_KEY: '',
  FILESTACK_API_KEY: '',
  FILESTACK_DISABLED: false,
  IMAGIFER_URL: '',
  UPPY_HOST: '',
  UPPY_SOURCES: [],
  API_HOST: '',
  TEMPLATE_HOST: '',
  API_GATEWAY_HOST: '',
  CLIENT_ID: '',
  USER_AGENT: '',
  POLOTNO_API_KEY: '',
  POLOTNO_REMOTE_PDFER_URL: '',
  INSTAGRAM_APP_ID: '',
  INSTAGRAM_REDIRECT_URI: '',
  INSTAGRAM_URL: '',
  GEDCOM_API_URL: '',
  DRAFTS_WSS_URL: '',
  GENERATOR_DEBUG: false,
};

export default SETTINGS;
